import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import SaleLoader from 'app/Components/Shared/SaleLoader/SaleLoader.js';
import PurpleInfo from 'app/Components/Shared/PurpleInfo/PurpleInfo';
import Image from 'app/Components/Shared/Image/image';
import { checkProvisioningStatusAsync } from '../premiumPackagesCatalogAsyncThunk';
import Config from 'app/Config';
import alertIcon from '../images/alert-yellow.svg';
import './provisioningPage.scss';

const ProvisioningPage = (props) => {
    const intervalRef = useRef(null);
    const { title, subtitle, actionBtnText, isComplete, isTimeout, wasConnected, timeoutImage, hideActionBtn, pollingIntervalMs } = props.provisioningPage;

    useEffect(() => {
        if (!isComplete) {
            props.checkProvisioningStatusAsync();
            intervalRef.current = setInterval(() => {
                props.checkProvisioningStatusAsync();
            }, pollingIntervalMs || 10000);
        } else {
            clearInterval(intervalRef.current);
        }
        return () => clearInterval(intervalRef.current);
    }, [isComplete]);

    function handleActionBtn() {
        const connectClientName = props.connectClientName ?? 'HBO';
        const redirectUrl = connectClientName === 'DISNEY' ? Config.redirectToDisneyUrl : Config.redirectToHboUrl;
        props.context.navigateTo(redirectUrl);
    }

    const isDisney = props.connectClientName === 'DISNEY';
    const streamingBrand = isDisney ? 'דיסני+' : 'HBO';

    return (
        <div className="provisioning-page">
            <h2 className="provisioning-page__title">{title}</h2>
            {wasConnected ? (
                <PurpleInfo
                    text={
                        <>
                            זיהינו שכבר היה לך חשבון {streamingBrand},
                            <br />
                            יש להתחבר עם החשבון שנרשמת איתו
                            <br />
                            כדי להתחיל לצפות בתכנים
                        </>
                    }
                >
                    <div className="provisioning-page__info-icon-wrapper">
                        <Image src={alertIcon} alt="" className="provisioning-page__info-icon" />
                    </div>
                </PurpleInfo>
            ) : (
                <p className="provisioning-page__subtitle" style={isTimeout ? {height: 'unset'} : {}}>{subtitle}</p>
            )}

            {!isTimeout && (
                <div
                    className="provisioning-page__loader"
                    style={{
                        visibility: isComplete ? 'hidden' : 'visible'
                    }}
                >
                    <SaleLoader />
                </div>
            )}

            {isTimeout && (
                <div className="provisioning-page__timeout-image">
                    <Image src={timeoutImage} alt="" />
                </div>
            )}

            {!hideActionBtn && <BtnSubmit text={actionBtnText} disabled={!isComplete} onclick={handleActionBtn} />}
        </div>
    );
};

const mapStateToProps = (state) => ({
    provisioningPage: state.premiumPackagesCatalog.provisioningPage,
    connectClientName: state.streamingRegistrationSlice?.connectClientName,
});

const mapDispatchToProps = {
    checkProvisioningStatusAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProvisioningPage);
